import React from 'react';
import ModalComponent from '../../components/ModalComponent';
import '../../assets/style/Modal.css';
import { CLICK_ACTIONS } from '../../utils/Constant';
import SuccessStarTick from '../../assets/img/sucessStarTick.svg';

import ModalHeader from '../../components/ModalHeader';
import { Col, Image, Row } from 'react-bootstrap';
import { Button, Label } from 'reactstrap';
import { addFourDigitsToTheId, formattedDate } from '../../utils/Util';

interface ISuccessfullyApprovedModalProps {
  isOpen: boolean;
  toggleModal: (action?: string) => void;
  reimbursementDetails: any;
}

const SuccessfullyApprovedModal: React.FunctionComponent<
  ISuccessfullyApprovedModalProps
> = ({
  isOpen,
  toggleModal,
  reimbursementDetails,
}: ISuccessfullyApprovedModalProps) => {
  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="d-flex justify-content-center">
        <div className="bg-white rounded border re-modal-width">
          <div className="m-2">
            <ModalHeader toggle={toggleModal} closeOnly />
            <div className="d-flex justify-content-center">
              <Image
                src={SuccessStarTick}
                roundedCircle
                width={120}
                height={120}
              />
            </div>
            <div className="d-flex justify-content-center">
              <p style={{ fontWeight: 400, fontSize: '20px' }}>
                A Claim ID{' '}
                <strong>
                  {addFourDigitsToTheId(reimbursementDetails?.claimId)}
                </strong>{' '}
                has been Successfully Approved
              </p>
            </div>
          </div>

          <div className="re-parent">
            <Row>
              <Col xs={6} md={4} className="re-claim-date-picker re-row-margin">
                <Label className="mb-0 model-label-name">Employee Id</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {reimbursementDetails?.employeeUniqueId}
                </Label>
              </Col>
              <Col xs={6} md={4} className="re-claim-date-picker re-row-margin">
                <Label className="mb-0 model-label-name">Employee Name</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {reimbursementDetails?.fullName}
                </Label>
              </Col>
              <Col xs={6} md={4} className="re-claim-date-picker re-row-margin">
                <Label className="mb-0 model-label-name">Role</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {reimbursementDetails?.roleName}
                </Label>
              </Col>
            </Row>
            <Label className="re-claim-detail">Claim Details</Label>

            <Row>
              <Col xs={6} md={4} className="re-claim-date-picker re-row-margin">
                <Label className="mb-0 model-label-name">Claim Id</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {addFourDigitsToTheId(reimbursementDetails?.claimId)}
                </Label>
              </Col>
              <Col xs={6} md={4} className="re-claim-date-picker re-row-margin">
                <Label className="mb-0 model-label-name">Claim Date</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {formattedDate(reimbursementDetails?.createdOn)}
                </Label>
              </Col>
              <Col xs={6} md={4} className="re-claim-date-picker re-row-margin">
                <Label className="mb-0 model-label-name">Type Of Claim</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {reimbursementDetails?.claimType}
                </Label>
              </Col>
            </Row>
          </div>
          <div className="d-flex justify-content-center re-button-parent">
            <Button
              variant="outline-primary"
              className="cl-btn-primary"
              onClick={() => toggleModal(CLICK_ACTIONS.NO_ACTION)}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </ModalComponent>
  );
};

export default SuccessfullyApprovedModal;
